<template>
  <div class="space-y-4">
    <FormGroup
      label="What did you like?"
      :help="helperText"
      required
    >
      <Textarea
        v-model="localPros"
        :rows="3"
        placeholder="Share the positives"
        class="w-full resize-none"
        :maxlength="maxLength"
      />
      <small class="text-gray-500">{{ maxLength - localPros.length }} characters remaining</small>
    </FormGroup>
    <FormGroup
      label="What could be improved?"
      required
    >
      <Textarea
        v-model="localCons"
        :rows="3"
        placeholder="Share the negatives"
        class="w-full resize-none"
        :maxlength="maxLength"
      />
      <small class="text-gray-500">{{ maxLength - localCons.length }} characters remaining</small>
    </FormGroup>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  pros: string
  cons: string
  maxLength: number
  helperText?: string
}>()
const emit = defineEmits<{
  'update:pros': [value: string]
  'update:cons': [value: string]
}>()
const localPros = computed({
  get: () => props.pros,
  set: value => emit('update:pros', value)
})
const localCons = computed({
  get: () => props.cons,
  set: value => emit('update:cons', value)
})
</script>
